import { createBlock } from './block';
import { Block } from '@chameleoncreator/creator-app';
import { LessonStatus } from 'store/store';
export interface SCORMProps {
  shouldSendScoreWhen: string;
  moduleCompleteInterationRequirement: string;
  moduleCompleteScoreRequirement: boolean;
  scormExitMessage: string;
  scormExitDelay: boolean;
  scormControlledExit: boolean;
  sendOnlySuccessStatus: boolean;
  lessonStatus: LessonStatus;
}

export const createScorm = (
  props: SCORMProps = {
    scormExitMessage: 'logout',
    shouldSendScoreWhen: 'NEVER',
    moduleCompleteInterationRequirement: 'allInteractionsSeen',
    moduleCompleteScoreRequirement: false,
    scormControlledExit: false,
    scormExitDelay: false,
    sendOnlySuccessStatus: false,
    lessonStatus: 'completed/incomplete',
  }
): Block => {
  return createBlock('SCORM', [], {
    props: {
      shouldSendScoreWhen: props.shouldSendScoreWhen,
      moduleCompleteInterationRequirement:
        props.moduleCompleteInterationRequirement,
      moduleCompleteScoreRequirement: props.moduleCompleteScoreRequirement,
      scormControlledExit: props.scormControlledExit,
      scormExitDelay: props.scormExitDelay,
      scormExitMessage: props.scormExitMessage,
      sendOnlySuccessStatus: props.sendOnlySuccessStatus,
      lessonStatus: props.lessonStatus,
    },
  });
};
